import React, { useEffect, useState, useMemo, useRef } from 'react'
import CommonTable from '../../../../../components/common/common-table/common-table'
import ItipsForProduct from '../../../../../components/common/i-tips/product'
import { commonFilterFn, nbsStr } from '../../../../../services/lib/utils/helpers'
import getImage from '../../../../../components/common/common-form/common-image'
import { ButtonsForPageLink } from '../../manager/work-arrangement/work-arrangement-presentation-only-page'
import { imgStringToArray } from '../../../../../components/common/common-column-components/common-edit-image-component'
import { Button, Modal, Popover, Upload, UploadFile, Image } from 'antd'
import Plate from '../../../../warehouse/plate'
import MaintenanceLogDialog from '../../../../product/maintenance-log-page/maintenance-log-dialog'

const SuborderCommonTable = (props: {isPackaging?: boolean, selectedMachine: any, tableData: any, getStatusButton: any, onMaintenanceLogVisibleChange?: (visible: boolean) => void}) => {
  const {isPackaging, selectedMachine, tableData, getStatusButton, onMaintenanceLogVisibleChange} = props
  const [isPlateModalVisible, setIsPlateModalVisible] = useState(false)
  const [isMaintenanceLogVisible, setIsMaintenanceLogVisible] = useState(false)
  const openMaintenanceLog = () => { setIsMaintenanceLogVisible(true); onMaintenanceLogVisibleChange?.(true) }
  const closeMaintenanceLog = () => { setIsMaintenanceLogVisible(false); onMaintenanceLogVisibleChange?.(false) }
  const footerDataRef = useRef({ jobs: 0, total_qty: 0 }) // 使用 ref 存储 footer 数据
  const debounceTimerRef = useRef<any>(null) // 防抖计时器
  // 日期统一显示为 dd/mm/yyyy (与 Purchase Order 页面保持一致)
  const formatDdMmYyyy = (dateString: any) => {
    if (!dateString) return null
    const d = new Date(dateString + '.000Z')
    if (isNaN(d.getTime())) return null
    const p = (n: number) => String(n).padStart(2, '0')
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`
  }



  useEffect(() => {
    setFooterInfo(tableData)
  }, [tableData])
  
  const getRenderData = (data: any) => {
    const renderData: any = []
    data.map((row: any) => {
      renderData.push({
        ...row,
        serialNumber: row.workOrder?.serialNumber, // 优先使用 WorkOrderNo，如果没有则使用 SerialNumber
        product: row.workOrder?.product,
        productId: row.workOrder?.product?.productId,
        productName: row.workOrder?.product?.productName,
        productCode: row.workOrder?.product?.productCode,
        productImage: row.workOrder?.product?.images,
        urgent: row.workOrder?.urgent,
        suborderStatusName: row.suborderStatus?.suborderStatusName,
        completedDate: formatDdMmYyyy(row.completedDate),
        requiredDate1: row.workOrder?.requiredDate,
        requiredDate: formatDdMmYyyy(row.workOrder?.requiredDate),
        // receivedQuantity - 
      })
    })
    
    // 前端排序：状态 > Urgent > 时间(日期+时间) > 工单号 > SuborderId
    renderData.sort((a: any, b: any) => {
      // 1. 按状态ID排序：statusId=2（做/Pr）优先级最高
      const getStatusPriority = (statusId: any) => {
        const numStatusId = typeof statusId === 'string' ? parseInt(statusId, 10) : (statusId ?? 0)
        if (numStatusId === 2) return 0
        return numStatusId + 1000
      }
      const statusA = a.suborderStatusId ?? 0
      const statusB = b.suborderStatusId ?? 0
      const priorityA = getStatusPriority(statusA)
      const priorityB = getStatusPriority(statusB)

      if (priorityA !== priorityB) {
        return priorityA - priorityB
      }

      // 2. 按Urgent排序：urgent=1 优先（排在前面），urgent=0 靠后
      const urgentA = a.urgent ? 1 : 0
      const urgentB = b.urgent ? 1 : 0
      if (urgentA !== urgentB) {
        return urgentB - urgentA // urgent=1 排在前面，所以用 urgentB - urgentA
      }

      // 3. 按时间排序（日期+时间，升序）
      const reqDateA = a.workOrder?.requiredDate ? new Date(a.workOrder.requiredDate).getTime() : Number.MAX_SAFE_INTEGER
      const reqDateB = b.workOrder?.requiredDate ? new Date(b.workOrder.requiredDate).getTime() : Number.MAX_SAFE_INTEGER
      if (reqDateA !== reqDateB) {
        return reqDateA - reqDateB
      }

      // 4. 按WorkOrderNo数字排序（升序）
      const woNoA = a.workOrder?.workOrderNo ? parseInt(a.workOrder.workOrderNo.trim(), 10) || Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER
      const woNoB = b.workOrder?.workOrderNo ? parseInt(b.workOrder.workOrderNo.trim(), 10) || Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER
      if (woNoA !== woNoB) {
        return woNoA - woNoB
      }

      // 5. 按SuborderId排序（升序，稳定排序）
      const suborderIdA = a.suborderId || ''
      const suborderIdB = b.suborderId || ''
      return suborderIdA.localeCompare(suborderIdB)
    })
    
    return renderData
  }

  const setFooterInfo = (data: any[]) => {
    let total_qty = 0
    for (let i = 0; i < data.length; i++) {
      total_qty += data[i]?.receivedQuantity || 0
    }
    
    // 更新 ref 中的数据
    footerDataRef.current = {
      jobs: data?.length || 0,
      total_qty: total_qty,
    }
    
    // 直接更新 DOM
    updateFooterDOM()
  }
 // 更新 DOM 元素的函数
  const updateFooterDOM = () => {
    // 使用 getElementById 获取元素
    const footerJobsElement = document.getElementById('footer-jobs')
    const footerQtyElement = document.getElementById('footer-qty')
    
    if (footerJobsElement) {
      footerJobsElement.textContent = footerDataRef.current.jobs.toString()
    }
    if (footerQtyElement) {
      footerQtyElement.textContent = footerDataRef.current.total_qty.toString()
    }
  }

  const onFilterChange = (tableRef: any) => {
    // 清除之前的定时器
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current)
    }
    
    // 设置新的防抖定时器
    debounceTimerRef.current = setTimeout(() => {
      if (tableRef && tableRef.current) {
        const searchedData = tableRef.current.dataManager.searchedData
        
        // 重新计算 footer
        let total_qty = 0
        for (let i = 0; i < searchedData.length; i++) {
          total_qty += searchedData[i]?.receivedQuantity || 0
        }
        
        // 更新 ref 数据
        footerDataRef.current = {
          jobs: searchedData?.length || 0,
          total_qty: total_qty,
        }
        
        // 直接更新 DOM
        updateFooterDOM()
      }
    }, 300) // 300ms 防抖延迟
  }
  let timer:any;
  const debounce = (func:any, timeout = 1000) =>{
    console.log("debouse")
    if (timer) clearTimeout(timer) 
    timer = setTimeout(() => { func(); }, timeout);
  }

  const myfiler=(
    filterValue:any,
    rowData:any
  ) => {
    const filter = filterValue?.replace(/-/g, '\u2011').trim();
    const prodName = (rowData?.replace(/-/g, '\u2011').trim())?.toUpperCase();
    if (prodName?.indexOf(filter?.toUpperCase()) >=0) return true;

    return false;
  }  


  const ImageWithHoverPreview = ({ url }: { url: string }) => {
    return (
      <Popover
        content={
          <Image
            src={url}
            preview={false}
            style={{ width: '800px', objectFit: 'contain' }}
          />
        }
        trigger="hover"
        overlayStyle={{ zIndex: 99999 }}   // 提高层级
        mouseEnterDelay={0.3}
        mouseLeaveDelay={0.1}
        placement="right"
        autoAdjustOverflow={true}
        getPopupContainer={() => document.body}  // 强制挂载到 body
      >
        <Image
          style={{ cursor: 'pointer' }}
          width={100}
          src={url}
          preview={false}
        />
      </Popover>
    )
  }
  return (
    <div>
      <Modal destroyOnClose={true} visible={isPlateModalVisible} onOk={() => setIsPlateModalVisible(true)} onCancel={() => setIsPlateModalVisible(false)} width={1200} footer={null}>
        <Plate cancelModal={() => setIsPlateModalVisible(false)} refresh={() => {
          return
        }}/>
      </Modal>
      <Modal destroyOnClose={true} visible={isMaintenanceLogVisible} onCancel={closeMaintenanceLog} title="Add Maintenance Log" width={700} footer={null}>
        <MaintenanceLogDialog selectedMachine={selectedMachine} onDialogClose={closeMaintenanceLog} />
      </Modal>
      <div style={{position: 'relative'}}>
        <div style={{marginBottom: '1rem', display: 'flex', alignItems: 'baseline'}}>
          <ButtonsForPageLink />
          <Button type={'primary'} onClick={() => setIsPlateModalVisible(true)} style={{marginTop: '1rem', marginRight: '10px'}}>Store To Pallet</Button>
        </div>
        {/* 给 span 元素添加 id，以便通过 getElementById 访问 */}
        <div style={{position: 'absolute', top: '130px', left: '26px'}}>
          <span><b>Total Jobs:&nbsp;</b><span id="footer-jobs">0</span>&nbsp;&nbsp;</span>
          <span><b>Total Qty:&nbsp;</b><span id="footer-qty">0</span>&nbsp;&nbsp;</span>
        </div>
        <style>
            {`
            .MuiTableCell-root:nth-last-child(2) {
            position: sticky !important;
            right: 20px;
            background: #fff;
            z-index: 4;
            }
          `}
        </style>
        <CommonTable
          title={
            (<div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center'}}>
              {/* 表格标题：缩小字号，避免挤占工具栏空间 */}
              <span style={{fontSize: '0.9rem', fontWeight: 600}}>{(isPackaging ? '打包/Packaging' : '子工单/Suborder') + ' ' + (selectedMachine ? `(Machine: ${selectedMachine.machineName})` : '')}</span>
              <Button type='primary' onClick={openMaintenanceLog} style={{marginLeft: '0.75rem'}}>
                Add Maintenance Log
              </Button>
            </div>) as any
          }
          initData={getRenderData(tableData)}
          onFilterChange={onFilterChange}
          disableSorting={true}
          column={[
            { title: '工单号\nNo.', field: 'serialNumber', type: 'numeric', customSort: (a: any, b: any) => {
              // 数字排序：将字符串转换为数字进行比较
              const numA = parseInt(a.serialNumber || '0', 10) || 0;
              const numB = parseInt(b.serialNumber || '0', 10) || 0;
              return numA - numB;
            }},
            { title: '产品代码/Product Code', field: 'productCode', customFilterAndSearch: ( filterValue:any,rowData:any) =>myfiler(filterValue, rowData.product?.productCode ) },
            { title: '产品/Product', field: 'productName', customFilterAndSearch:  ( filterValue:any,rowData:any) =>myfiler(filterValue, rowData.product?.productName ) , render: (rowData: any) => <ItipsForProduct id={rowData.productId} label={rowData.productName} isNotCutting={true} /> },
            selectedMachine?.machineTypeId==1?{ title: '原生产单数量\nOriginal Qty', field: 'orginalQuantity' }:{ title: '原生产单数量\nOriginal Qty', field: 'orginalQuantity' },
            {
              title: '产品图片/Product Image',
              field: 'productImage',
              render: (rowData: any) => {
                const fileList = imgStringToArray(rowData.productImage)
                return (
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {fileList.map((file: any, index: number) => (
                      <ImageWithHoverPreview key={index} url={file.url} />
                    ))}
                  </div>
                )
              }
            },
            { title: '已经生产数量/Produced Qty',
               field: 'ProducedQuantity',
              //  render: (rowData: any) => (rowData.orginalQuantity - rowData.receivedQuantity) || 0 },
              render: (rowData: any) => (rowData.productionQuantity) || 0 },
            {
              title: '优先/Urgent',
              field: 'urgent',
              // defaultSort: 'desc',
              lookup: {0: 'No', 1: 'Yes'},
              render: (rowData: any) => rowData.urgent ? <b style={{color: 'red'}}>Yes</b> : <span>No</span>
            },
            // {
            //   title: '备注/Notes',
            //   field: 'logsComment',
            //   render: (rowData: any) => (
            //     <div>
            //       <div style={{color:'blue'}}>{(rowData.workOrder.approvedComments&&rowData.workOrder.approvedComments!='Comment')?rowData.workOrder.approvedComments:null}</div>
            //       {
            //         rowData.logs?.map((row: any, index: any) => row.comment ? (
            //           <div key={index.toString()}>
            //             <b>{nbsStr((row.operEmployee?.firstName ? row.operEmployee.firstName[0].toUpperCase() + row.operEmployee.firstName.slice(1) : '') + ' ' + (row.operEmployee?.lastName ? row.operEmployee.lastName[0].toUpperCase() + row.operEmployee.lastName.slice(1) : ''))}:</b>&nbsp;{row.comment}
            //           </div>
            //         ) : null)
            //       }
            //       {
            //         rowData.logs?.map((row: any, index: any) => row.rawmaterialNotes ? (
            //           <div key={index.toString()}>
            //             <b>{nbsStr((row.operEmployee?.firstName ? row.operEmployee?.firstName[0].toUpperCase() + row.operEmployee?.firstName.slice(1) : '') + ' ' + (row.operEmployee?.lastName ? row.operEmployee?.lastName[0].toUpperCase() + row.operEmployee?.lastName.slice(1) : ''))}:</b>&nbsp;{row.rawmaterialNotes}
            //           </div>
            //         ) : null)
            //       }                  
            //     </div>
            //   )
            // },
            {
              title: '备注/Notes',
              field: 'logsComment',
              cellStyle: { minWidth: 180 },
              render: (rowData: any) => {
                const logs = rowData.logs || []

                // 备注内容有效性判断：null、'null' 字符串、纯空格都视为无内容，不显示该条
                const hasText = (v: any) => {
                  if (v === null || v === undefined) return false
                  const s = String(v)
                  return s.trim() !== '' && s !== 'null'
                }

                // 时间倒序：最近的备注排在前面
                const comments = logs
                  .filter((row: any) => hasText(row.comment))
                  .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

                const rawNotes = logs
                  .filter((row: any) => hasText(row.rawmaterialNotes))
                  .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

                const getName = (emp: any) => {
                  if (!emp) {
                    return 'Unknown'
                  }
                  const firstName = emp.firstName
                    ? emp.firstName[0].toUpperCase() + emp.firstName.slice(1)
                    : ''
                  const lastName = emp.lastName
                    ? emp.lastName[0].toUpperCase() + emp.lastName.slice(1)
                    : ''
                  return [firstName, lastName].filter(Boolean).join(' ') || 'Unknown'
                }

                const fmtTime = (v: any) => {
                  if (!v) return ''
                  const d = new Date(v)
                  if (isNaN(d.getTime())) return ''
                  const p = (n: number) => String(n).padStart(2, '0')
                  return `${p(d.getDate())}/${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`
                }

                const approved = (hasText(rowData.workOrder?.approvedComments)
                  && rowData.workOrder.approvedComments !== 'Comment')
                  ? rowData.workOrder.approvedComments
                  : null

                if (!approved && !comments.length && !rawNotes.length) {
                  return <span style={{ color: '#c0c0c0' }}>—</span>
                }

                // 员工名牌 chip：姓名 + 操作时间，姓名过长时省略号截断（悬停可看全名）
                const nameChip = (log: any, bg: string, fg: string) => {
                  const name = getName(log.operEmployee)
                  const time = fmtTime(log.createdAt)
                  return (
                    <span
                      title={time ? `${name} · ${time}` : name}
                      style={{
                        display: 'inline-flex', flexDirection: 'column', alignItems: 'center',
                        flexShrink: 0,
                        minWidth: '3.4rem', maxWidth: '5.5rem',
                        padding: '2px 6px', borderRadius: '6px',
                        backgroundColor: bg, color: fg,
                        fontSize: '11px', lineHeight: '14px',
                      }}
                    >
                      <b style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</b>
                      {/* {time && <span style={{ opacity: 0.75, whiteSpace: 'nowrap' }}>{time}</span>} */}
                    </span>
                  )
                }

                const noteRow = (key: string, chip: any, text: any) => (
                  <div key={key} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                    {chip}
                    <span style={{ flex: 1, fontSize: '12.5px', lineHeight: '18px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      {text}
                    </span>
                  </div>
                )

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '13rem' }}>
                    {/* 工单审批备注：蓝色横幅样式，与操作备注区分 */}
                    {approved && (
                      <div
                        title="审批备注/Approved Comment"
                        style={{
                          backgroundColor: '#e8f1fd', borderLeft: '3px solid #2196f3',
                          borderRadius: '4px', padding: '4px 8px',
                          fontSize: '12.5px', lineHeight: '18px', color: '#0d47a1',
                          whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                        }}
                      >
                        {approved}
                      </div>
                    )}

                    {/* 操作备注：绿色名牌 */}
                    {comments.map((c: any, idx: number) =>
                      noteRow(`c-${idx}`, nameChip(c, '#e8f5e9', '#1b5e20'), c.comment))}

                    {/* 原材料批号：蓝色名牌 */}
                    {rawNotes.map((r: any, idx: number) =>
                      noteRow(`r-${idx}`, nameChip(r, '#e3f2fd', '#0d47a1'), r.rawmaterialNotes))}
                  </div>
                )
              }
            },
            { title: '需要日期/REQ Date', field: 'requiredDate1', render: (rowData: any) => rowData.requiredDate },
            {
              title: '状态/Status',
              sorting: false,
              defaultFilter: ['1', '2', '3'],
              lookup: { '-1': '挂起/Pending', 1: '等/Aw', 2: '做/Pr', 3: '停/Pa', 4: '未准备好/NotReady', 9: '部分完成/PartlyComp', 10: '完成/Comp', 0: '取消/Canc' },
              customFilterAndSearch: (term: any, rowData: any) => term && term.length ? term.includes(rowData.suborderStatusId?.toString()) : true,
              render: (rowData:any) => (
                // <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                //   {/*<div>{rowData.suborderStatusName}</div>*/}
                // </div>
                <div style={{textAlign: 'center'}}>{getStatusButton(rowData)}</div>
              ),
            },
          ]}
        />
      </div>
    </div>
  )
}

export default SuborderCommonTable
